<script setup lang="ts">
import RepartitionFormationRepartition from '@/components/repartition-des-formations/RepartitionFormationRepartition.vue'
import RepartitionFormationsInfoCard from '@/components/repartition-des-formations/RepartitionFormationsInfoCard.vue'
import RepartitionFormationsTable from '@/components/repartition-des-formations/RepartitionFormationsTable.vue'
import DraggableContainer from '@/components/ui/draggable/DraggableContainer.vue'
import { useComponentOrder } from '@/lib/useComponentOrder'
import { markRaw } from 'vue'

const defaultComponents = [
  {
    id: 'info-card',
    component: markRaw(RepartitionFormationsInfoCard),
  },
  {
    id: 'repartition-chart',
    component: markRaw(RepartitionFormationRepartition),
  },
  {
    id: 'repartition-formation-table',
    component: markRaw(RepartitionFormationsTable),
  },
]

const { components } = useComponentOrder('repartition-des-formations-page', defaultComponents)
</script>

<template>
  <DraggableContainer v-model:components="components" />
</template>
